import { FeatureItems, FilterOption } from '@/types';
import { createActionCreator } from 'deox';

export const getFeatureItemsActions = {
  request: createActionCreator('GET_FEATURE_ITEMS_REQUEST', (resolve) => (arrayActiveFeature?: string[]) =>
    resolve({ arrayActiveFeature })
  ),
  success: createActionCreator(
    'GET_FEATURE_ITEMS_SUCCESS',
    (resolve) => (
      data: FeatureItems,
      apiFilterOption: FilterOption,
      appFilterOption: FilterOption,
      entityFilterOptions: FilterOption
    ) => resolve({ data, apiFilterOption, appFilterOption, entityFilterOptions })
  ),
  failure: createActionCreator('GET_FEATURE_ITEMS_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const clearFeaturesAction = {
  request: createActionCreator('CLEAR_FEATURES'),
};
